import { compose } from 'redux'
import { connect } from 'react-redux'
import { withProps } from 'recompose'
import { getHasActiveVehicleStatus } from 'selectors'
import { getActiveVehicleTireSize } from 'selectors/getActiveVehicle'
import { COMPATIBILITY_STATUS_NO_COMPATIBLE_MESSAGE, GENERAL_SOURCE, YMME_NAME } from 'constant'
import CompatibilityLabel from './CompatibilityLabel'
import { showNewShopTiresModal } from '../../NewShopTiresModal/actions'

const withEnhancedCompatibilityStatus = withProps(({
  disableCompatibilityMessage,
  status,
  showNewShopTiresModal
}) => ({
  status: disableCompatibilityMessage ? COMPATIBILITY_STATUS_NO_COMPATIBLE_MESSAGE : status,
  addVehicle: () => showNewShopTiresModal({
    isOnlyVehicle: true,
    ymmeName: YMME_NAME,
    withShowConfirmTireSizeModal: true,
    source: GENERAL_SOURCE
  })
}))

export default compose(
  connect(state =>
    ({
      disableCompatibilityMessage: getHasActiveVehicleStatus(state) && !getActiveVehicleTireSize(state)
    }),
  { showNewShopTiresModal }),
  withEnhancedCompatibilityStatus
)(CompatibilityLabel)
